import { defineStore } from "pinia";
import { isImageFile } from "../helpers/isImageFile";

export const useBrandingStore = defineStore("branding", {
  state: () => ({
    miniState: false,
    hasDelivery: true,
    hasIdentification: true,
    colors: {},
    logo: "",
    hostname: "",
    activeTab: "form",
    isLoading: false,
    isRedirect: false,
    currentGeolocation: null,
    shop: ""
  }),
  getters: {},
  actions: {
    setColors(value) {
      this.colors = {
        primary: value?.colors_accent_1,
        secondary: value?.colors_accent_2,
      };
    },
    setLogo(value) {
      if(!isImageFile(value)) return this.logo = ""
      this.logo = value;
    },
    setHostname(value) {
      this.hostname = value;
    },
    setMiniState(value) {
      this.miniState = value;
    },
    setCurrentGeolocation(value) {
      this.currentGeolocation = value;
    },
    setNullGeolocation() {
      this.currentGeolocation = null;
    },
    setShop(value) {
      this.shop = value;
    }
  },
});
